import { withBlankProgramOption } from 'src/components/Dashboard/utils/filterDefaults';
import { getProgramsOptions } from 'src/components/Groups/Programs/utils';

function getProgramFilterOptions(programs, { showProgramNameColumn, selected, query } = {}) {
  return withBlankProgramOption(getProgramsOptions(programs, { filters: { programs_filter: selected } }), {
    enabled: showProgramNameColumn,
    selected,
    query,
  });
}

export default getProgramFilterOptions;
